// @flow

import { schema } from 'normalizr';

export const coupon = new schema.Entity('coupons');

export const image = new schema.Entity('images');
export const video = new schema.Entity('video');

export const icon = new schema.Entity('icons');

export const land = new schema.Entity('lands');

const category = new schema.Entity('categories');
category.define({
  children: [category],
});
export { category };

const categorySummary = new schema.Entity('categorySummary');
categorySummary.define({
  children: [categorySummary],
});
export { categorySummary };

export const payment = new schema.Entity('payments');

export const profile = new schema.Entity('profile');
export const user = new schema.Entity('user');

export const offering = new schema.Entity('offerings', {
  images: [image],
  videos: [video],
});

export const wanted = new schema.Entity('wanteds');

export const question = new schema.Entity('questions');

export const bookmark = new schema.Entity('bookmarks', offering);

export const invoice = new schema.Entity('invoices');

export const purchase = new schema.Entity('purchases', {
  offering,
  escrow_invoice: invoice,
  escrow_invoice_no_buyer_offer: invoice,
  settle_up_invoice: invoice,
  draft_settle_up_invoice: invoice,
});

export const sale = new schema.Entity('sales', {
  offering,
  escrow_invoice: invoice,
  escrow_invoice_no_buyer_offer: invoice,
  settle_up_invoice: invoice,
  draft_settle_up_invoice: invoice,
});

export const purchaseSchema = new schema.Entity('purchaseSchema');
export const saleSchema = new schema.Entity('saleSchema');

export const saleTicket = new schema.Entity('saleTickets');
export const purchaseTicket = new schema.Entity('purchaseTickets');
export const saleLand = new schema.Entity('saleLands');
export const purchaseLand = new schema.Entity('purchaseLands');
export const waiver = new schema.Entity('waiver');

export const chatMessage = new schema.Entity('chatMessages');
export const chatUser = new schema.Entity('chatUsers');
export const chat = new schema.Entity('chats', {
  user: chatUser,
});

export const notification = new schema.Entity('notifications');

export const paymentMethod = new schema.Entity('paymentMethods');
export const attachment = new schema.Entity('attachments');

export const build = new schema.Entity('builds');

export const review = new schema.Entity('reviews');
export const reviewDimension = new schema.Entity('reviewDimensions');
export const reviewStar = new schema.Entity('reviewStars');

export const supplyProposal = new schema.Entity('supplyProposal');
